
<template>
  <v-app>    
    <PageWrapper></PageWrapper>  
  </v-app>
</template>

<script>
import PageWrapper from './components/PageWrapper.vue';

export default {
  name: 'App',
  components: {
    PageWrapper
}
}
</script>
<style>
html {
  overflow: auto !important;
}
html, body {  
  width: 100;
  height: 100%;
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;  
  width: 100;
  height: 100%;
  padding: 0;
  margin: 0;
}

</style>
